import { render, staticRenderFns } from "./DistrictsComponent.vue?vue&type=template&id=0d470d3b&scoped=true"
import script from "./DistrictsComponent.vue?vue&type=script&lang=js"
export * from "./DistrictsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d470d3b",
  null
  
)

export default component.exports